export const removeTrailingSlash = (url: string) => url.replace(/\/?$/, '');

export const appendTrailingSlash = (url: string) =>
  url.replace(/\/?(\?|#|$)/, '/');
